<template>
	<div class="food-checker-container">
		<h1>Food Checker</h1>
		<form @submit.prevent="submit" class="form mt-4">
			<image-upload v-model="imagePreview" />

			<!-- Image Preview -->
			<div v-if="imagePreview" class="image-preview">
				<img
					:src="imagePreview"
					alt="Meal preview"
					class="img-thumbnail mt-2" />
			</div>

			<!-- Submit Button -->
			<button type="submit" class="btn btn-success mt-3" :disabled="!isOnline">
				Submit
			</button>
		</form>

		<!-- Bootstrap Modal -->
		<div
			v-if="showModal"
			class="modal fade show d-block"
			tabindex="-1"
			role="dialog">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Food Checking Results</h5>
						<button
							type="button"
							class="btn-close"
							data-dismiss="modal"
							aria-label="Close"
							@click="closeModal">
							<span aria-hidden="true"></span>
						</button>
					</div>
					<div class="modal-body text-center">
						<img
							:src="result.safe ? smiley : skull"
							alt="Result Image"
							class="result-image img-fluid mb-5" />
						<div v-if="!result.safe" class="issues">
							<div v-for="issue in result.issues" :key="issue.item">
								<p>
									<strong>{{ issue.item }}:</strong>
									{{ issue.contains.join(", ") }}
								</p>
							</div>
						</div>
						<div v-else>
							<h2>FOOD IS SAFE!</h2>
						</div>
						<div
							class="nutrition"
							v-if="result.nutrition && result.nutrition.length">
							<h3>Nutritional Information</h3>
							<div
								v-for="item in result.nutrition"
								:key="item.item"
								class="nutrition-item">
								<h4>{{ item.item }}</h4>
								<p>Calories: {{ item.calories }}</p>
								<p>Fibers: {{ item.fibers }}g</p>
								<p>Sugar: {{ item.sugar }}g</p>
								<p>Fats: {{ item.fats }}g</p>
								<p>Sodium: {{ item.sodium }}mg</p>
								<p>Carbs: {{ item.carbs }}g</p>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button
							type="button"
							class="btn btn-secondary"
							data-dismiss="modal"
							@click="closeModal">
							Close
						</button>
					</div>
				</div>
			</div>
		</div>
		<div v-if="showModal" class="modal-backdrop fade show"></div>
	</div>
</template>

<script setup>
	import { ref } from "vue"
	import { startLoading, stopLoading } from "@/utils/loaderBus"
	import Swal from "sweetalert2"
	// import { useTokenStore } from "@/stores/token"
	// import { hasTokenIssue, handleTokenIssue } from "@/utils/tokenIssue"
	import { fetchWithAuth } from "@/utils/api-client"
	import skull from "@/assets/skull.webp"
	import smiley from "@/assets/smiley.webp"
	import { isOnline } from "@/utils/networkBus"
	import ImageUpload from "@/components/ImageUpload.vue"

	// const tokenStore = useTokenStore()

	const imagePreview = ref(null)
	const result = ref(null)
	const showModal = ref(false)

	const closeModal = () => {
		showModal.value = false
	}

	const submit = async () => {
		if (!imagePreview.value) {
			Swal.fire({ icon: "error", title: "Image is required" })
			return
		}

		startLoading()

		const formData = new FormData()
		// formData.append("file", image.value)

		// const resp = await fetch(imagePreview.value)
		// const blob = await resp.blob()
		formData.append("file", imagePreview.value)

		try {
			// Make the POST request using fetch
			const response = await fetchWithAuth("/api/food-checker", {
				method: "POST",
				// headers: {
				// 	Authorization: `Bearer ${tokenStore.token}`,
				// },
				body: formData,
			})

			stopLoading()

			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			const responseData = await response.json()

			if (!response.ok) {
				// alert(responseData.message)
				Swal.fire({
					icon: "error",
					title: responseData.message ?? responseData.error,
				})
			} else {
				// Reset the form and preview image
				// image.value = null
				imagePreview.value = null

				result.value = responseData
				showModal.value = true
			}
			// }
		} catch (error) {
			// Handle error
			console.error("Error submitting meal:", error)
			Swal.fire({ icon: "error", title: error.message })
		}

		stopLoading()
	}
</script>

<style lang="less" scoped>
	@import "../assets/colors.less";

	.result-image {
		width: 200px;
		height: auto;
	}

	.issues p {
		margin: 0;
		padding: 0.5rem;
	}
	.nutrition {
		margin-top: 20px;
	}

	.nutrition-item {
		border: 1px solid @color4;
		padding: 10px;
		margin-bottom: 10px;
	}

	// .btn-outline-orange {
	// 	border-color: @color4;
	// 	color: @color4;
	// }

	.food-checker-container {
		max-width: 600px;
		margin: auto;
		padding: 1rem;
	}

	// .image-upload-buttons {
	// 	display: flex;
	// 	justify-content: start;
	// 	gap: 1rem;

	// 	.btn {
	// 		position: relative;
	// 		i {
	// 			margin-right: 8px;
	// 		}
	// 	}

	// 	input[type="file"] {
	// 		position: absolute;
	// 		width: 100%;
	// 		height: 100%;
	// 		top: 0;
	// 		left: 0;
	// 		opacity: 0;
	// 		cursor: pointer;
	// 	}
	// }

	.image-preview img {
		max-width: 100%;
		height: auto;
	}
</style>
